import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios";

interface UseToggleContactDocumentProps {
  contactId?: string
  establishmentLeadId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: () => void
}

export const useToggleContactDocument = ({ contactId, establishmentLeadId, onSuccess, onError }: UseToggleContactDocumentProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['toggleContactDocument'],
    mutationFn: ({ value, type, documentId }: { value: boolean, type: string, documentId?: string }) => {
      const lead = {
        contacts_attributes: [
          {
            id: contactId,
            documents_attributes: [
              value
                ? { type }
                : { id: documentId, _destroy: true }
            ]
          }
        ]
      }

      return privateAxios.putForm(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
